// React
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

// Libraries
import { clsx } from 'clsx'

// Components
import BRadioGroup from 'ui/blocks/RadioGroup'
import Span from 'ui/elements/Span'
import Icon from 'ui/components/Icon'

export const RadioBox = ({
  label,
  checked,
  description,
  children,
  onClick,
  exclusive,
  bordered,
  modifiers,
  'data-tid': target,
  displayUpgradeIcon
}) => {
  const showChildren = (children && !exclusive) || (children && checked)

  const nestedModifiers = typeof modifiers === 'object' ? modifiers : { self: modifiers }

  const renderLabel = (modifiers) => {
    const children = (
      <BRadioGroup.Label modifiers={clsx(modifiers, displayUpgradeIcon && 'display-inline-block width-auto')}>
        {label}
      </BRadioGroup.Label>
    )

    if (displayUpgradeIcon) {
      return (
        <Span modifiers="display-flex align-items-center gap-1 relative">
          {children}
          <Icon icon="sparkles" color="Accent7/Base" style="fas" modifiers="font-size-md transform-top-3" />
        </Span>
      )
    }

    return children
  }

  return (
    <Fragment>
      <BRadioGroup.Radio
        modifiers={nestedModifiers.radioGroup}
        checked={checked}
        onClick={onClick}
        bordered={bordered}
        data-tid={target}
      >
        <BRadioGroup.RadioButton icon="circle" modifiers={nestedModifiers.radioGroupIcon} />
        {renderLabel(nestedModifiers.radioGroupLabel)}
        {description && <BRadioGroup.Description>{description}</BRadioGroup.Description>}
        {showChildren && <BRadioGroup.ChildContainer>{children}</BRadioGroup.ChildContainer>}
      </BRadioGroup.Radio>
    </Fragment>
  )
}

export default RadioBox

RadioBox.propTypes = {
  'checked': PropTypes.bool,
  'label': PropTypes.any,
  'description': PropTypes.any,
  'children': PropTypes.node,
  'onClick': PropTypes.func,
  'exclusive': PropTypes.bool,
  'bordered': PropTypes.bool,
  'data-tid': PropTypes.string,
  'modifiers': PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  'displayUpgradeIcon': PropTypes.bool
}
